import { forwardRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import {
    DashlyFilterDropdown,
    type DashlyFilterDropdownProps,
} from "../DashlyFilterDropdown/DashlyFilterDropdown";
import "./FilterDropdown.scss";

export type FilterDropdownProps = DashlyFilterDropdownProps;

/**
 * @deprecated Use {@link DashlyFilterDropdown}. Kept for backward-compatible imports.
 */
const FilterDropdown = forwardRef<Dropdown, FilterDropdownProps>(function FilterDropdown(
    { className, ...rest },
    ref,
) {
    return (
        <DashlyFilterDropdown
            ref={ref}
            {...rest}
            className={classNames("spoofy-filter-dropdown", className)}
        />
    );
});

FilterDropdown.displayName = "FilterDropdown";

export { FilterDropdown };
